import React from 'react';
import Navbar from 'components/navigation/web/Navbar';
import { useTranslation } from 'react-i18next';
import { Avatar, Card, CardHeader, IconButton, Typography, Grid } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import SettingsIcon from '@mui/icons-material/Settings';
import AutoGraphIcon from '@mui/icons-material/AutoGraph';
import ManageHistoryIcon from '@mui/icons-material/ManageHistory';
import SwitchAccountIcon from '@mui/icons-material/SwitchAccount';
import LaunchIcon from '@mui/icons-material/Launch';
import { getBorder, getBackground } from 'utils/Styles';
import { useNavigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';

const gettingAllowViews = (t, navigate, items) => {
    if (localStorage.getItem('access_token')) {
        const views = jwtDecode(localStorage.getItem('access_token'))?.views;

        if (views.some((view) => /\/settings/.test(view))) {
            items.push({
                icon: (
                    <Avatar>
                        {' '}
                        <SettingsIcon />{' '}
                    </Avatar>
                ),
                title: t('home.quick_access.settings'),
                subheader: 'Subheader',
                action: (
                    <IconButton onClick={() => navigate('/settings')} sx={{ mt: 0.35 }}>
                        {' '}
                        <MoreVertIcon />{' '}
                    </IconButton>
                ),
                redirect: () => navigate('/settings'),
            });
        }

        if (views.some((view) => /\/timekeeper/.test(view))) {
            items.push({
                icon: (
                    <Avatar>
                        {' '}
                        <AutoGraphIcon />{' '}
                    </Avatar>
                ),
                title: t('home.quick_access.timekeeper'),
                subheader: 'Subheader',
                action: (
                    <IconButton onClick={() => navigate('/timekeeper')} sx={{ mt: 0.35 }}>
                        {' '}
                        <MoreVertIcon />{' '}
                    </IconButton>
                ),
                redirect: () => navigate('/timekeeper'),
            });
        }

        if (views.some((view) => /\/user_management/.test(view))) {
            items.push({
                icon: (
                    <Avatar>
                        {' '}
                        <SwitchAccountIcon />{' '}
                    </Avatar>
                ),
                title: t('home.quick_access.user_management'),
                subheader: 'Subheader',
                action: (
                    <IconButton onClick={() => navigate('/user_management')} sx={{ mt: 0.35 }}>
                        {' '}
                        <MoreVertIcon />{' '}
                    </IconButton>
                ),
                redirect: () => navigate('/user_management'),
            });
        }

        if (views.some((view) => /\/custom_reports/.test(view))) {
            items.push({
                icon: (
                    <Avatar>
                        {' '}
                        <SwitchAccountIcon />{' '}
                    </Avatar>
                ),
                title: t('home.quick_access.custom_reports'),
                subheader: 'Subheader',
                action: (
                    <IconButton onClick={() => navigate('/custom_reports')} sx={{ mt: 0.35 }}>
                        {' '}
                        <MoreVertIcon />{' '}
                    </IconButton>
                ),
                redirect: () => navigate('/custom_reports'),
            });
        }

        if (views.some((view) => /\/accruals/.test(view))) {
            items.push({
                icon: (
                    <Avatar>
                        {' '}
                        <SwitchAccountIcon />{' '}
                    </Avatar>
                ),
                title: t('home.quick_access.accruals'),
                subheader: 'Subheader',
                action: (
                    <IconButton onClick={() => navigate('/accruals')} sx={{ mt: 0.35 }}>
                        {' '}
                        <MoreVertIcon />{' '}
                    </IconButton>
                ),
                redirect: () => navigate('/accruals'),
            });
        }

        if (views.some((view) => /\/schedule-rules/.test(view))) {
            items.push({
                icon: (
                    <Avatar>
                        {' '}
                        <ManageHistoryIcon />{' '}
                    </Avatar>
                ),
                title: 'Reglas de Horario',
                subheader: 'Subheader',
                action: (
                    <IconButton onClick={() => navigate('/schedule-rules')} sx={{ mt: 0.35 }}>
                        {' '}
                        <MoreVertIcon />{' '}
                    </IconButton>
                ),
                redirect: () => navigate('/schedule-rules'),
            });
        }

        items.push({
            icon: (
                <Avatar>
                    {' '}
                    <ManageHistoryIcon />{' '}
                </Avatar>
            ),
            title: 'Reglas de Horario',
            subheader: 'Subheader',
            action: (
                <IconButton onClick={() => navigate('/schedule-rules')} sx={{ mt: 0.35 }}>
                    {' '}
                    <MoreVertIcon />{' '}
                </IconButton>
            ),
            redirect: () => navigate('/schedule-rules'),
        });

        items.push({
            icon: (
                <Avatar>
                    {' '}
                    <SwitchAccountIcon />{' '}
                </Avatar>
            ),
            title: t('home.quick_access.accruals'),
            subheader: 'Subheader',
            action: (
                <IconButton onClick={() => navigate('/accruals')} sx={{ mt: 0.35 }}>
                    {' '}
                    <MoreVertIcon />{' '}
                </IconButton>
            ),
            redirect: () => navigate('/accruals'),
        });
    } else {
        return [];
    }
};

const QuickAccess = () => {
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();

    const items = [];

    gettingAllowViews(t, navigate, items);

    const tkConfigSystem = (() => {
        const rawConfig = localStorage.getItem('tk_config_system');
        if (!rawConfig) {
            return [];
        }

        try {
            const parsed = JSON.parse(rawConfig);
            return Array.isArray(parsed) ? parsed : [];
        } catch {
            return [];
        }
    })();

    const tatDashboardBaseUrl = tkConfigSystem.find((c) => c.key === 'base_url_tat_dashboard')?.value ?? null;
    const locale = i18n.language?.toLowerCase().startsWith('en') ? 'en' : 'es';
    const loggedUsername = (localStorage.getItem('username') || '').trim();
    const tatSsoUrl = (() => {
        if (!tatDashboardBaseUrl) {
            return '';
        }

        try {
            const targetUrl = new URL(tatDashboardBaseUrl);
            targetUrl.pathname = `/${locale}/sso/start/tk-dev`;

            if (loggedUsername) {
                targetUrl.searchParams.set('authuser', loggedUsername);
            }

            return targetUrl.toString();
        } catch (error) {
            console.warn('No se pudo construir la URL de MyPalTime con REACT_APP_TAT_DASHBOARD_BASE_URL', error);
            return '';
        }
    })();

    items.push({
        icon: (
            <Avatar>
                {' '}
                <LaunchIcon />{' '}
            </Avatar>
        ),
        title: 'MyPalTime',
        subheader: 'SSO',
        action: (
            <IconButton onClick={() => window.open(tatSsoUrl, '_blank', 'noopener,noreferrer')} sx={{ mt: 0.35 }}>
                {' '}
                <MoreVertIcon />{' '}
            </IconButton>
        ),
        redirect: () => window.open(tatSsoUrl, '_blank', 'noopener,noreferrer'),
        disabled: !tatSsoUrl,
    });

    return (
        <>
            <Typography variant="h6" sx={{ padding: 1, mx: 2 }}>
                {t('home.quick_access.title')}
            </Typography>

            <Grid container spacing={2} sx={{ padding: 1, mx: 2 }}>
                {items.map((item, index) => (
                    <Grid key={index} item size={{ xs: 12, sm: 6, md: 4, lg: 3, xl: 3 }}>
                        <Card
                            sx={{
                                boxShadow: 'none',
                                border: (theme) => getBorder(theme.palette.mode),
                                opacity: item.disabled ? 0.6 : 1,
                                ':hover': item.disabled ? {} : { background: (theme) => getBackground(theme.palette.mode), cursor: 'pointer' },
                            }}
                            onClick={item.disabled ? undefined : item.redirect}
                        >
                            <CardHeader
                                avatar={<div>{item.icon}</div>}
                                title={item.title}
                                subheader={item.subheader}
                                action={item.disabled ? React.cloneElement(item.action, { disabled: true }) : item.action}
                            />
                        </Card>
                    </Grid>
                ))}
            </Grid>
        </>
    );
};

const Home = () => {
    const { t } = useTranslation();

    return (
        <>
            <Navbar
                view={{
                    title: t('home.title'),
                    component: <QuickAccess />,
                }}
                right={{
                    title: 'Right',
                    component: <></>,
                }}
            />
        </>
    );
};

export { Home };
